import { GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { ToolsState } from '@/store/tools/types';
import { timers } from 'jquery';

export const getters: GetterTree<ToolsState, RootState> = {
};
